import React, { useContext, useEffect, useState } from "react";
import { TabList } from "../../components/common/TabList.js";
import { CarouselContext } from "pure-react-carousel";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
//Styling
import "./MediaShowcase.css";

export const MediaShowcase = (props) => {
  const { detailData } = props;

  let videos = detailData["videos"].filter((item) => item.site == "YouTube");

  let tabListItems = [
    { key: 0, name: "Video", content: <VideoShowcase videoItems={videos} /> },
    {
      key: 1,
      name: "Backdrop",
      content: <ImageShowcase imageItems={detailData["backdrops"]} />,
    },
  ];

  return (
    <div className="media_showcase_container">
      <TabList tabListItems={tabListItems} id={detailData.id}/>
    </div>
  );
};

export const VideoShowcase = (props) => {
  let { videoItems } = props;
  let [currentItem, setCurrentItem] = useState(null);

  useEffect(() => {
    if (videoItems.length > 0) {
      let initialVideo = videoItems.find(
        (item) => item.name.includes("trailer") || item.name.includes("Trailer")
      );
      if (initialVideo) {
        setCurrentItem(initialVideo);
      }
    }
  }, [videoItems]);

  if (videoItems.length === 0) {
    return (
      <div className="video_showcase_wrapper">
        <span>Sorry, no videos found</span>
      </div>
    );
  }

  function switchVideo(vidKey) {
    if (currentItem.key != vidKey) {
      let targetItem = videoItems.filter((item) => item.key == vidKey)[0];
      setCurrentItem(targetItem);
    }
  }

  return (
    <div className="video_showcase_wrapper">
      <div className="iframe_container">
        {currentItem && (
          <iframe
            src={`https://www.youtube.com/embed/${currentItem.key}`}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        )}
      </div>
      <div className="vid_list_wrapper">
        {currentItem &&
          videoItems.map((item) => (
            <div
              className={`vid_list_item ${
                item.key == currentItem.key ? "vid_list_item_active" : ""
              }`}
              key={item.key}
              onClick={() => switchVideo(item.key)}
            >
              {item.name}
            </div>
          ))}
      </div>
    </div>
  );
};

export const ImageShowcase = (props) => {
  let { imageItems } = props;
  let [currentImg, setCurrentImg] = useState(null);
  let [autoPlay, setAutoPlay] = useState(true);

  let visibleSlides = 1;
  let slideSize = {
    width: "calc(40vw)",
    height: "calc(30vw)",
  };

  //Update Control List Order
  function updateImgOrder(imgIdx) {
    let listLength = imageItems.length;
    if (imgIdx === currentImg) {
      return 0;
    } else if (imgIdx > currentImg) {
      return imgIdx - currentImg;
    } else {
      return imgIdx - currentImg + listLength;
    }
  }

  return (
    <div className="image_showcase_wrapper">
      <CarouselProvider
        className="image_showcase_container carousel_container"
        naturalSlideWidth={slideSize.width}
        naturalSlideHeight={slideSize.height}
        totalSlides={imageItems.length}
        isIntrinsicHeight={true}
        touchEnabled={true}
        visibleSlides={visibleSlides}
        dragEnabled={true}
        dragStep={1}
        interval={3000}
        isPlaying={autoPlay}
        lockOnWindowScroll={true}
        infinite={true}
      >
        <MyComponentUsingContext
          imageItems={imageItems}
          currentItem={currentImg}
          setCurrentItem={setCurrentImg}
          autoPlay={autoPlay}
        />
      </CarouselProvider>
      <div
        className="image_showcase_control_wrapper"
        onMouseOver={() => setAutoPlay(false)}
        onMouseOut={() => setAutoPlay(true)}
      >
        {imageItems.map((item, index) => (
          <div
            className={`img_showcase_control_item ${
              index == currentImg ? "control_item_active" : ""
            }`}
            key={index}
            style={{ order: updateImgOrder(index) }}
            onClick={() => {
              setCurrentImg(index);
            }}
          >
            <img src={item.file_path} />
          </div>
        ))}
      </div>
    </div>
  );
};

// Carousel Component to keep track with current slide
export function MyComponentUsingContext(props) {
  let { imageItems, currentItem, setCurrentItem, autoPlay } = props;
  const carouselContext = useContext(CarouselContext);
  const [currentSlide, setCurrentSlide] = useState(
    carouselContext.state.currentSlide
  );
  useEffect(() => {
    function onChange() {
      setCurrentSlide(carouselContext.state.currentSlide);
    }
    carouselContext.subscribe(onChange);
    if (currentItem != currentSlide) {
      setCurrentItem(currentSlide);
    }
    return () => carouselContext.unsubscribe(onChange);
  }, [currentSlide]);

  useEffect(() => {
    if (!autoPlay) {
      if (currentItem != currentSlide) {
        carouselContext.setStoreState({ currentSlide: currentItem });
      }
    }
  }, [currentItem]);

  return (
    <Slider moveThreshold={0.1} className="image_showcase_slider">
      {imageItems.map((item, index) => (
        <Slide index={index} key={index}>
          <div className="image_showcase_item">
            <img className="image_showcase_item_img" src={item.file_path} />
          </div>
        </Slide>
      ))}
    </Slider>
  );
}
